/*global Adcurve, $, Intercom */
Adcurve.onLoad(function () {
  $('#open-intercom').click(function() {
    Intercom('show');
  })
});
